<template>
  <b-modal
    :title="$t('Create Condition Report Requests')"
    :visible="conditionReportModal"
    @hide="onModalHide"
    @close="onModalHide"
    @cancel="onModalHide"
    static
    lazy
  >
    <ValidationObserver ref="observer">
      <ConditionReportRequestForm @submit="onSubmit" ref="conditionForm"/>
    </ValidationObserver>
    <template #modal-footer>
      <b-button variant="primary" size="sm" class="mx-2" @click="submitForm" :disabled="loading">
        {{ $t('Submit') }}
        <b-spinner v-if="loading" small class="ml-2"/>
      </b-button>
      <b-button variant="secondary" size="sm" @click="onModalHide">
        {{ $t('Cancel') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import UpcomingAmountPopover from "../lot-view/UpcomingAmountPopover.vue";
import TaxRateAndPremiums from "@/components/TaxRateAndPremiums.vue";
import CalculatedPremium from "@/components/lot-view/CalculatedPremium.vue";
import BidAmount from "@/components/lot-view/BidAmount.vue";
import BidTotalAmount from "@/components/lot-view/BidTotalAmount.vue";
import MaxBidForm from "@/components/configuration/lot-list-item/MaxBidForm.vue";
import InputWidget from "@/components/core/InputWidget.vue";
import ConditionReportRequestForm from "@/components/condition-report/ConditionReportRequestForm.vue";
import i18n from "@/i18n";

export default {
  name: "ConditionReportRequestModal",
  components: {
    ConditionReportRequestForm,
    InputWidget,
    MaxBidForm,
    BidTotalAmount,
    BidAmount,
    CalculatedPremium,
    TaxRateAndPremiums,
    UpcomingAmountPopover
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState({
      conditionReportModal: state => state.lotObject.conditionReportModal,
      lot: state => state.lotObject.data,
    }),
    ...mapGetters(['is_authorized']),
  },
  methods: {
    ...mapMutations(['setShowConditionReportModal', 'showNotification']),
    ...mapActions(['createConditionReportRequest']),
    onModalHide() {
      this.setShowConditionReportModal(false)
    },
    async submitForm() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        await this.onSubmit();
      }
    },
    async onSubmit() {
      this.loading = true;

      const response = await this.createConditionReportRequest(this.getPayload());

      if (response.status === 201) {
        this.showNotification({
          title: i18n.t('Request created'),
          text: i18n.t('Condition Report Requests was created successfully.'),
          variant: 'success',
        });
        this.onModalHide();
      } else if (response.status === 200) {
        this.showNotification({
          title: i18n.t('Request confirmation required'),
          text: i18n.t('Please check your email to confirm your request.'),
          variant: 'success',
          duration: 10000,
        });
        this.onModalHide();
      } else {
        this.showNotification({
          title: i18n.t('Server error'),
          text: i18n.t("Please try again."),
          variant: 'danger',
        });
      }

      this.loading = false;
    },
    getPayload() {
      const formData = this.$refs.conditionForm;
      return {
        lot_uuid: this.lot.uuid,
        message: formData.message,
        ...(!this.is_authorized ? {
          first_name: formData.firstName,
          last_name: formData.lastName,
          email: formData.email,
        } : {}),
      }
    },
  }
}
</script>
